"use client";

import { useEffect, useState } from "react";

interface GreetingComponentProps {
  name: string;
}

export const GreetingComponent = (props: GreetingComponentProps) => {
  const [greeting, setGreeting] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!props.name) {
      return; // Don't proceed if name is not yet available
    }

    const currentHour = new Date().getHours();

    if (currentHour >= 4 && currentHour < 12) {
      setGreeting(`Goedemorgen, ${props.name}!`);
    } else if (currentHour >= 12 && currentHour < 18) {
      setGreeting(`Goedemiddag, ${props.name}!`);
    } else if (currentHour >= 18 && currentHour < 23) {
      setGreeting(`Goedenavond, ${props.name}!`);
    } else {
      setGreeting(`Goedenacht, ${props.name}!`);
    }
    setIsLoading(false);
  }, [props.name]);

  if (isLoading) {
    return (
      <div className="h-8 md:h-10"/>
    );
  }

  return <>{greeting}</>;
};
